'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var PeerId = require('peer-id');

var ensureMultiaddr = require('./utils').ensureMultiaddr;

var MultiaddrSet = require('./multiaddr-set');

var assert = require('assert'); // Peer represents a peer on the IPFS network


var PeerInfo =
/*#__PURE__*/
function () {
  function PeerInfo(peerId) {
    _classCallCheck(this, PeerInfo);

    assert(peerId, 'Missing peerId. Use Peer.create(cb) to create one');
    this.id = peerId;
    this.multiaddrs = new MultiaddrSet();
    this.protocols = new Set();
    this._connectedMultiaddr = undefined;
  } // only stores the current multiaddr being used


  _createClass(PeerInfo, [{
    key: "connect",
    value: function connect(ma) {
      ma = ensureMultiaddr(ma);

      if (!this.multiaddrs.has(ma) && ma.toString() !== "/ipfs/".concat(this.id.toB58String())) {
        throw new Error('can\'t be connected to missing multiaddr from set');
      }

      this._connectedMultiaddr = ma;
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this._connectedMultiaddr = undefined;
    }
  }, {
    key: "isConnected",
    value: function isConnected() {
      return this._connectedMultiaddr;
    }
  }]);

  return PeerInfo;
}();

PeerInfo.create = function (peerId, callback) {
  if (typeof peerId === 'function') {
    callback = peerId;
    peerId = null;
    PeerId.create(function (err, id) {
      if (err) {
        return callback(err);
      }

      callback(null, new PeerInfo(id));
    });
    return;
  } // Already a PeerId instance


  if (typeof peerId.toJSON === 'function') {
    callback(null, new PeerInfo(peerId));
  } else {
    PeerId.createFromJSON(peerId, function (err, id) {
      return callback(err, new PeerInfo(id));
    });
  }
};

PeerInfo.isPeerInfo = function (peerInfo) {
  return Boolean(typeof peerInfo === 'object' && peerInfo.id && peerInfo.multiaddrs);
};

module.exports = PeerInfo;